<template>
  <div v-if="!ready" v-loading="!ready" element-loading-text="拼命加载中" class="page-loading"></div>
  <div v-else>
    <el-row class="m-t-20 p-20 block" type="flex" justify="space-between" align="center">
      <div class="flex-box column p-b-20">
        <h1>{{detail.title}}</h1>
        <span :class="'status'+detail.status">[{{status[detail.status]}}]</span>
      </div>
      <div class="flex-box row">
        <router-link class="el-button el-button--success el-button--cons" :to="$location.notice_list({},false)">
          返回
        </router-link>
      </div>
    </el-row>
    <el-row class="m-t-20 p-20 block">
      <el-form :model="detail" label-width="100px">
        <el-form-item v-for="item in form" :label="item.name" :prop="item.prop" :key="item.prop">
          <span class="p-l-20 text-pre-wrap" style="display:inline-block;">{{detail[item.prop]}}</span>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import * as Notice from 'api/notice'

export default {
  data () {
    return {
      ready: false,
      detail: null,
      form: null,
      status: null,
    }
  },
  methods: {
    init () {
      this.ready = false
      this.$guard()(async () => {
        let [detail, status, form] = await Promise.all([Notice.get(this.$query.notice_uid), Notice.status(), Notice.form_all()])
        this.detail = detail
        this.form = form
        this.status = status
        this.ready = true
      })
    },
  },
  created () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>

<style scoped lang="scss">
.flex-box.column {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}

.flex-box.row {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.block {
  background: white;
  .status0 {
    color: red;
    font-weight: bold;
  }

  .status1 {
    color: deepskyblue;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticeDetail.vue